import instance, { ADMIN_PREFIX } from 'services/api';
import { Attribute, AttributeGroup } from 'types/api/attributes';

export const fetchAttributeGroups = (lang: string) =>
  instance.get<AttributeGroup[]>(`${ADMIN_PREFIX}/attributes/groups`, {
    headers: { locale: lang }
  });

// `place_used` is serialized as repeated query params (?place_used=2&
// place_used=4&…). FE constants store these as numeric codes; BE
// controller normalizes via string | string[].
export const fetchAttributesPlaceUse = (placeUse: Array<string | number>) =>
  instance.get<Attribute[]>(`${ADMIN_PREFIX}/attributes/place-use`, {
    params: { place_used: placeUse }
  });
